module.exports = __webpack_public_path__ + "img/local-department.acebbf6a.webp";